import { type FC } from 'react'
import { Controller, type RegisterOptions } from 'react-hook-form'

import Dropdown, { type DropdownProps } from '@DS/components/forms/dropdown/Dropdown'

type ControlDropdownProps = {
  id?: string
  name: string
  rules?: RegisterOptions
} & DropdownProps

const ControlDropdown: FC<ControlDropdownProps> = ({ name, rules, options, id, onChange, ...rest }) => (
  <Controller
    name={name}
    rules={rules}
    defaultValue={rest.defaultValue}
    render={({ field: { value, onChange: onChangeField, ref }, fieldState: { error } }) => (
      <Dropdown
        {...rest}
        ref={ref}
        id={id}
        required={!!rules}
        options={options}
        helperText={!!error && error.message}
        value={value}
        onChange={(event, child) => {
          onChangeField(event.target.value)
          onChange?.(event, child)
        }}
      />
    )}
  />
)

export default ControlDropdown
